import {destroyToken} from "../authentication";
import Cookies from 'js-cookies';
import Requests from "./Requests";

export default {
    mixins: [Requests],
    methods: {
        logoutUser () {
            this.getPromise(this.$store.state.endpoints.logout);
            destroyToken();
            Cookies.removeItem('csrftoken');
            localStorage.clear();
        },
        setUserLanguage(lang) {
            if (this.$store.getters.isAuthenticated) {
                this.patchPromise(
                    this.$store.state.endpoints.userInfo,
                    {
                        lang: lang.toUpperCase(),
                    }
                )
            }
        },
    },
    computed: {
        loggedIn () {
            return this.$store.getters.isAuthenticated
        },
        // authenticated() {
        //     return this.loggedIn;
        // }
    }
}
